"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var SupplierPriceRecalculation_1 = require("../model/SupplierPriceRecalculation");

var SupplierPriceRecalculationConverter_1 = require("./SupplierPriceRecalculationConverter");
/**
 *
 * Implementation of {@link SupplierPriceRecalculationConverter}
 */


var SupplierPriceRecalculationConverterImpl =
/*#__PURE__*/
function (_SupplierPriceRecalcu) {
  _inherits(SupplierPriceRecalculationConverterImpl, _SupplierPriceRecalcu);

  function SupplierPriceRecalculationConverterImpl() {
    _classCallCheck(this, SupplierPriceRecalculationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierPriceRecalculationConverterImpl).apply(this, arguments));
  }

  _createClass(SupplierPriceRecalculationConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SupplierPriceRecalculation_1.SupplierPriceRecalculation(SupplierPriceRecalculation_1.SupplierPriceRecalculation.schema.supplierAgreementId.valueOf(conversions.toClassReferenceId(source.supplierAgreementId)), SupplierPriceRecalculation_1.SupplierPriceRecalculation.schema.regularPurchasePriceRecalculate.valueOf(!utils_1.Utils.isValueMissing(source.regularPurchasePriceRecalculate) ? conversions.toBigNumber(source.regularPurchasePriceRecalculate) : null), SupplierPriceRecalculation_1.SupplierPriceRecalculation.schema.promoPurchasePriceRecalculate.valueOf(!utils_1.Utils.isValueMissing(source.promoPurchasePriceRecalculate) ? conversions.toBigNumber(source.promoPurchasePriceRecalculate) : null), SupplierPriceRecalculation_1.SupplierPriceRecalculation.schema.promoPurchasePricePlusRecalculate.valueOf(!utils_1.Utils.isValueMissing(source.promoPurchasePricePlusRecalculate) ? conversions.toBigNumber(source.promoPurchasePricePlusRecalculate) : null));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        supplierAgreementId: conversions.toDocumentReferenceId(source.supplierAgreementId),
        regularPurchasePriceRecalculate: source.regularPurchasePriceRecalculate !== null ? conversions.fromBigNumber(source.regularPurchasePriceRecalculate) : null,
        promoPurchasePriceRecalculate: source.promoPurchasePriceRecalculate !== null ? conversions.fromBigNumber(source.promoPurchasePriceRecalculate) : null,
        promoPurchasePricePlusRecalculate: source.promoPurchasePricePlusRecalculate !== null ? conversions.fromBigNumber(source.promoPurchasePricePlusRecalculate) : null
      });
      return result;
    }
  }]);

  return SupplierPriceRecalculationConverterImpl;
}(SupplierPriceRecalculationConverter_1.SupplierPriceRecalculationConverter);

exports.SupplierPriceRecalculationConverterImpl = SupplierPriceRecalculationConverterImpl;